// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f7e6a864","513":"4abcacc0","703":"6fabd384","787":"f0ef9463"}[chunkId] + ".chunk.js";
};